import {useContext} from "react";
import {CompanyApprovalContext} from "../../tools/contexts/companyApproval/CompanyApprovalContext";
import Card from "../cards/Card";
import Button from "../Button";
import {BiCheck} from "react-icons/bi";
import {Reoverlay} from "reoverlay";
import ConfirmModal from "../modals/ConfirmModal";

const Widget=()=>{
    const companyApprovalContext=useContext(CompanyApprovalContext);
    const widget=companyApprovalContext.widget;

    const handleDelete=()=>{
        Reoverlay.showModal(ConfirmModal,{
            title:'حذف افزونه',
            message:'افزونه از روی آگهی شما حذف خواهد شد. آیا مطمئن هستید؟',
            confirmButtonText:'حذف افزونه',
            cancelButtonText:'بستن',
            showConfirmButton:true,
            showCancelButton:true,
            confirmButtonTheme:"red",
            cancelButtonTheme:"light",
            onConfirm:async () => {
                Reoverlay.hideModal()
                await companyApprovalContext.handleDeleteWidget()
            },
            onCancel:()=>{
                Reoverlay.hideModal()
            }
        })
    }
    return <div className="w-11/12 mx-auto lg:w-6/12 xl:w-4/12">
        <Card className="mt-10 rounded-xl shadow-sm">
            <div>

                <div className="w-full flex justify-center">
                    <div className="w-16 h-16 flex justify-center items-center p-3 bg-green-100 rounded-full">
                        <BiCheck className="text-4xl text-green-500"/>
                    </div>
                </div>
                <p className="py-2 mt-2 mb-2 font-bold text-center">اطلاعات افزونه شما</p>
            </div>
            <div className="grid grid-cols-1">
                <div className="grid py-2   grid-cols-2">
                    <span className="text-sm">نام شرکت</span>
                    <span className="font-semibold text-sm">{widget.widgets_body.company_name}</span>
                </div>

                <div className="grid py-2   grid-cols-2">
                    <span className="text-sm">تاریخ استعلام</span>
                    <span className="font-semibold text-sm">{widget.widgets_body.bi_date}</span>
                </div>
            </div>
            <div className="grid mt-2 border-t pt-2  grid-cols-2">

                <Button onClick={companyApprovalContext.handleRedirect} theme="link" rounded="rounded-lg" className="text-sm">بازگشت</Button>
                <Button onClick={handleDelete} theme="red" rounded="rounded-lg" className="text-sm">حذف افزونه</Button>
            </div>

        </Card>
    </div>
}
export default Widget;